import { Breakpoints } from '@doordash/design-language'
import * as React from 'react'

const isWindowDesktopWidth = () =>
  (window && window.innerWidth > Breakpoints.Mobile) || false

export const useDesktopBreakpoint = () => {
  const [isDesktopWidth, setIsDesktopWidth] = React.useState(
    isWindowDesktopWidth
  )

  const handleIsDesktopWidth = React.useCallback(() => {
    const isDesktop = isWindowDesktopWidth()
    if (isDesktopWidth !== isDesktop) {
      setIsDesktopWidth(isDesktop)
    }
  }, [isDesktopWidth])

  React.useEffect(() => {
    handleIsDesktopWidth()
    window.addEventListener('resize', handleIsDesktopWidth)

    return () => window.removeEventListener('resize', handleIsDesktopWidth)
  }, [handleIsDesktopWidth, isDesktopWidth])

  return isDesktopWidth
}

export default useDesktopBreakpoint
